import { wrapSvg } from '../../../util/SvgImage';

export const Asterisk = wrapSvg(
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1897 10.7267L11.164 8H12.9646L12.8103 10.701L15.4598 9.92926L16 11.4469L13.3505 12.3987L15.074 14.5595L13.6077 15.6141L12.0643 13.2476L10.4695 15.6141L9.00322 14.5595L10.701 12.373L8 11.5498L8.61736 9.85209L11.1897 10.7267Z"
      fill="currentColor"
    />
  </svg>,
);
